---
nb:
  production_scheduling:
    dialog:
      close: Lukk
      day_ahead_hint: "«Nullast for i morgen» og «Spesifikk last for i morgen» påvirker kun day-ahead-budet som sendes før budfristen kl. 12:00. Dagens timer og kontinuerlige/instant-oppdateringer endres ikke."
      end_date: Sluttdato
      end_hour: Slutttime
      instant_send_note: Når du bekrefter, sendes intervallene som faller innenfor de neste {days} dagene umiddelbart til markedet via InstantSender (instant operations plan). Senere intervaller kommer til markedet gjennom den automatiske flyten når de kommer innenfor dette vinduet. Den planlagte produksjonen oppdateres i Volum- og pris-diagrammet under Prognose-fanen.
      instant_send_out_of_window: Det valgte tidsrommet starter utenfor markedsvinduet på {days} dager, så ingenting sendes umiddelbart til markedet. Overstyringen oppdaterer likevel prognosen og den planlagte produksjonen, og kommer til markedet gjennom den automatiske flyten når den kommer innenfor vinduet.
      instant_send_partial_window: Det valgte tidsrommet strekker seg utenfor markedsvinduet på {days} dager. Intervallene innenfor vinduet sendes umiddelbart til markedet; de senere gjør det ikke, og kommer til markedet gjennom den automatiske flyten når de kommer innenfor vinduet.
      override_type: Overstyringstype
      production_mw: Produksjon (MW)
      send: Send til Kaia Trade
      start_date: Startdato
      start_hour: Starttime
      success: Sendt {count} intervaller ({accepted} godkjent, {rejected} avvist)
      timezone_hint: Alle tider er i {timezone}
      title: Send overstyring for {name}
    filter:
      all: Alle
      disabled: Av
      enabled: På
      label: 'Produksjonsplan:'
    om_dashboard_link: Åpne O&M-dashbord
    override_types:
      specific_load_interval: Spesifikk last for et tidsintervall
      specific_load_tomorrow: Spesifikk last for i morgen
      zero_load_tomorrow: Nulllast for i morgen
    production_plan_toggle:
      error: 'Klarte ikke å oppdatere produksjonsplan: {error}'
      label: Produksjonsplan
    send_override: Send overstyring
    shadow_toggle:
      error: 'Klarte ikke å oppdatere skyggetesting: {error}'
      label: Skyggetesting
    table:
      actions: Handlinger
      company: Selskap
      continuous_forecast_enabled: Kontinuerlig prognose
      day_ahead_forecast_enabled: Day-ahead prognose
      forecast_query_enabled: Prognoseforespørsel
      kaia_uuid: Kaia UUID
      last_error: Siste kjente feil
      last_override_sent: Sist overstyring sendt
      last_prod_plan_sent: Sist prod.plan sendt til Trade
      name: Kraftverk
      production_simulation_plan_enabled: Produksjonsplan
      shadow_testing: Skyggetesting
      use_price_dependent_bid: Prisavhengig bud
    title: Prod. planlegging
